import { select, parseData } from "@assets/scripts/utils";
import AnimatedFigure from './AnimatedFigure'

export function animateRepeat (elements, options = {}) {

    if(typeof elements === 'string') {
        elements = document.querySelectorAll(elements)
    }

    elements = [].map.call(elements, el => el)

    const animations = elements.map(el => new AnimatedFigure(el, parseData(el)))

    return animations
}

export function animateScrolling (elements) {
    return select(elements).map(element => {
        const data = Object.assign(parseData(element), { count: 0, interval: 0, delay: 0 })
        const animation = new AnimatedFigure(element, data)
        animation.run()
        return animation
    })
}

export function animateWaypoint (elements) {
    return select(elements).map(element => {
        return new AnimatedFigure(element, parseData(element))
    })
}

export default {
    animateRepeat, animateScrolling, animateWaypoint
}
